"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * @phrospr/backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.6.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseIActivitySearchEntity = void 0;
const iactivity_search_entity_sort_1 = require("./iactivity-search-entity-sort");
const iactivity_search_filter_entity_1 = require("./iactivity-search-filter-entity");
const iactivity_search_show_entity_1 = require("./iactivity-search-show-entity");
function parseIActivitySearchEntity(data) {
    if (data.sort !== null && typeof data.sort === 'object')
        data.sort = (0, iactivity_search_entity_sort_1.parseIActivitySearchEntitySort)(data.sort);
    if (data.filter !== null && typeof data.filter === 'object')
        data.filter = (0, iactivity_search_filter_entity_1.parseIActivitySearchFilterEntity)(data.filter);
    if (data.show !== null && typeof data.show === 'object')
        data.show = (0, iactivity_search_show_entity_1.parseIActivitySearchShowEntity)(data.show);
    return data;
}
exports.parseIActivitySearchEntity = parseIActivitySearchEntity;
